import { Injectable } from '@angular/core';
import {
  BASE_PERMISSIONS,
  BaseOfferStatus,
  BaseRolesService,
  CustomerInquiryOfferListItemResponse,
  CustomerOfferListItemResponse,
} from 'base';
import { BaseCustomerWorkCouncilStatusEnum } from '../_enums/base-customer-work-council-status.enum';
import { BaseCustomerLocationWorkCouncilSettingsInterface } from '../_interfaces/base-customer-location-work-council-settings.interface';

@Injectable()
export class BaseCustomerOfferActionsService {
  constructor(private rolesService: BaseRolesService) {}

  checkAcceptButtonAvailability(
    offer: CustomerOfferListItemResponse | CustomerInquiryOfferListItemResponse,
    locationWorkCouncilSettings: BaseCustomerLocationWorkCouncilSettingsInterface
  ): boolean {
    if (
      !this.rolesService.isNotWorkCouncilAndHasPermission(BASE_PERMISSIONS.FEATURE_ACCEPT_OFFER) ||
      offer.status !== BaseOfferStatus.open
    ) {
      return false;
    }

    if (!locationWorkCouncilSettings.workCouncilActivated) {
      return true;
    }

    if (
      locationWorkCouncilSettings.acceptOfferAfterPreselection &&
      offer.preselected &&
      offer.workCouncilStatus !== BaseCustomerWorkCouncilStatusEnum.DISAPPROVED
    ) {
      return true;
    }

    return (
      locationWorkCouncilSettings.acceptOfferAfterWorkCouncilApproval &&
      (offer.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.APPROVED ||
        offer.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.AUTO_APPROVED ||
        offer.workCouncilStatus === BaseCustomerWorkCouncilStatusEnum.NOTED)
    );
  }

  checkRejectButtonAvailability(offer: CustomerOfferListItemResponse | CustomerInquiryOfferListItemResponse): boolean {
    return (
      offer.status === BaseOfferStatus.open &&
      this.rolesService.isNotWorkCouncilAndHasPermission(BASE_PERMISSIONS.FEATURE_ACCEPT_OFFER)
    );
  }

  checkWithdrawButtonAvailability(
    offer: CustomerOfferListItemResponse | CustomerInquiryOfferListItemResponse
  ): boolean {
    return (
      offer.status === BaseOfferStatus.needsConfirmation &&
      this.rolesService.isNotWorkCouncilAndHasPermission(BASE_PERMISSIONS.FEATURE_ACCEPT_OFFER)
    );
  }

  checkPreselectButtonAvailability(
    offer: CustomerOfferListItemResponse | CustomerInquiryOfferListItemResponse
  ): boolean {
    return (
      !offer.preselected &&
      offer.status === BaseOfferStatus.open &&
      this.rolesService.isNotWorkCouncilAndHasPermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS)
    );
  }

  checkUnselectButtonAvailability(
    offer: CustomerOfferListItemResponse | CustomerInquiryOfferListItemResponse,
    locationWorkCouncilSettings: BaseCustomerLocationWorkCouncilSettingsInterface
  ): boolean {
    return (
      this.rolesService.isNotWorkCouncilAndHasPermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS) &&
      offer.preselected &&
      offer.status === BaseOfferStatus.open &&
      ((!locationWorkCouncilSettings.workCouncilActivated && !this.rolesService.hasWorkCouncilRole()) ||
        (locationWorkCouncilSettings.workCouncilActivated && !offer.workCouncilStatus))
    );
  }
}
